// extracted by mini-css-extract-plugin
export default {"root":"Submissions__root--Htsd0a","loader":"Submissions__loader--+3Ia4z"};